export default "__VITE_ASSET__Mm2vYj38__"